
<div class="container pb-4">
  @if (!auth.isMenu('projects_flag')) {
    <div class="card-deck text-center"
      >
      <app-control-index-card class="card mb-4 box-shadow"
        [title]="'Физ лица'"
        [description]="'Таблица со всеми физическими лицами системы'"
        [url]="'/physical/list'"
      ></app-control-index-card>
      <app-control-index-card class="card mb-4 box-shadow"
        [title]="'Юр лица'"
        [description]="'Таблица со всеми юридическими лицами системы'"
        [url]="'/entity/list'"
      ></app-control-index-card>
    </div>
  }
  @if (auth.isMenu('projects_flag')) {
    <div class="card-deck text-center"
      >
      <app-control-index-card class="card mb-4 box-shadow"
        [title]="'Планировки'"
        [description]="'Помещения с незаполненными планировками'"
        [url]="'/control/layouts'"
      ></app-control-index-card>
      <!--    <app-control-index-card class="card mb-4 box-shadow"-->
      <!--                            [title]="'Условия реализации'"-->
      <!--                            [description]="'Помещения с незаполненными условиями реализации'"-->
      <!--                            [url]="'/control/conditions'"-->
    <!--    ></app-control-index-card>-->
    <app-control-index-card class="card mb-4 box-shadow"
      [title]="'Не связанные объекты'"
      [description]="'Ожидающие связи объекты в фидах импорта без обязательных полей'"
      [url]="'/control/not-imported'"
    ></app-control-index-card>
  </div>
}
<div class="card-deck text-center">
  @if (auth.isAdmin()) {
    <app-control-index-card class="card mb-4 box-shadow"
      [title]="'XML импорт'"
      [description]="'Проблемных импортов за последнюю неделю'"
      [url]="'/import'"
      [count]="counts['incorrect_import']"
      [loading]="load"
    ></app-control-index-card>
  }
  @if (auth.isMenu('instateka_is')) {
    <app-control-index-card class="card mb-4 box-shadow"
      [title]="'Ошибки Инстатека'"
      [description]="'Таблица с ошибками методов сервиса Инстатека'"
      [url]="'/instateka/errors'"
      [count]="counts['not_resolve_error']"
      [loading]="load"
    ></app-control-index-card>
  }
<!--  @if (auth.isFullAccess('projects_flag')) {-->
<!--    <app-control-index-card class="card mb-4 box-shadow"-->
<!--      [title]="'Регламенты и Акты'"-->
<!--      [description]="'ЖК с незаполненными регламентами или актами просмотра'"-->
<!--      [url]="'/mass/regl_table'"-->
<!--      [count]="counts['not_regl_or_act_complexes']"-->
<!--      [loading]="load_long"-->
<!--    ></app-control-index-card>-->
<!--  }-->
  @if (!auth.isAdmin() && auth.isMenu('email_exception_is')) {
    <app-control-index-card class="card mb-4 box-shadow"
      [title]="'Email исключения'"
      [description]="'Почты-исключения для блок-списка рассылки'"
      [url]="'/email-exception'"
    ></app-control-index-card>
  }
</div>
<div class="card-deck text-center">
  @if (auth.isAdmin()) {
    <app-control-index-card class="card mb-4 box-shadow"
      [title]="'Эст-а-тет ЖК'"
                            [description]="'Не установленные ассоциации ЖК систем Эст-а-тет и СПН24
                            (для корректной автоматической обработки квалификаций)'"
      [url]="'/eat-complex-captions'"
      [count]="counts['eat_not_assoc_complexes']"
      [loading]="load"
    ></app-control-index-card>
  }
  @if (auth.isAdmin()) {
    <app-control-index-card class="card mb-4 box-shadow"
      [title]="'Ошибки Celery'"
      [description]="'Необработанные ошибки микросервисов'"
      [url]="'/celery-err-log'"
      [count]="counts['celery_tasks_to_mark']"
      [loading]="load"
    ></app-control-index-card>
  }
  @if (auth.isAdmin()) {
    <app-control-index-card class="card mb-4 box-shadow"
      [title]="'Жалобы на объекты'"
      [description]="'Необработанные жалобы на объекты вторичного рынка'"
      [url]="'/complaints-datatable'"
      [count]="counts['resale_complaints']"
      [loading]="load"
    ></app-control-index-card>
  }
</div>
@if (auth.isFullAccess('projects_flag')) {
  <div class="card-deck text-center"
    >
    <app-control-index-card class="card mb-4 box-shadow"
      [title]="'УВ на застройщиках'"
                            [description]="developer_condition_warn
                            ? 'Скоро заканчивается срок установленных условий выплат на застройщиках на витрине'
                            : 'Застройщики на витрине с незаполненными' + (
                            counts['developer_conditions']?.['on_showcase']?.['developers_ends_soon']
                            ? ' и скоро заканчивающимися'
                            : ''
                            ) + ' условиями выплат'"
      [url]="'/condition/developer'"
      [count]="developer_condition_n"
      [loading]="load_long"
      [isWarning]="developer_condition_warn"
    ></app-control-index-card>
    <app-control-index-card class="card mb-4 box-shadow"
      [title]="'КВ на жилых комплексах'"
                            [description]="complexes_condition_warn
                            ? 'Скоро заканчивается срок установленных комиссионных вознаграждений на ЖК на витрине'
                            : 'ЖК на витрине с незаполненными' + (
                            counts['developer_conditions']?.['on_showcase']?.['complexes_ends_soon']
                            ? ' и скоро заканчивающимися'
                            : ''
                            ) + ' комиссионными вознаграждениями'"
      [url]="'/condition/developer'"
      [count]="complexes_condition_n"
      [loading]="load_long"
      [isWarning]="complexes_condition_warn"
    ></app-control-index-card>
  </div>
}

</div>
